import { formOptions } from './blocks'

/** Product type options: same categories as FixedDesign (exclude collection, suit_2_pieces, suit_3_pieces, default) */
const PRODUCT_TYPE_OPTIONS = Object.entries(formOptions)
  .filter(
    ([key]) =>
      !['collection', 'suit_2_pieces', 'suit_3_pieces', 'belt', 'sunglasses', 'default'].includes(key)
  )
  .map(([key, opt]) => ({ key, label: opt.name }))

/** Base form: product type + preset name. Sizes array is handled separately in the views. */
export const ProductSizeForm = {
  title: 'Product size preset',
  key: [],
  sections: [
    {
      columns: 2,
      fields: [
        {
          label: 'Product type',
          key: ['productType'],
          isRequired: true,
          type: 'select',
          placeholder: 'Select product type',
          options: PRODUCT_TYPE_OPTIONS,
          pos: { col: 1, row: 1, size: 1 },
        },
        {
          label: 'Preset name (EN)',
          key: ['name', 'en'],
          isRequired: true,
          placeholder: 'e.g. Standard Vest',
          pos: { col: 1, row: 2, size: 1 },
        },
        {
          label: 'Preset name (中文)',
          key: ['name', 'zh'],
          isRequired: false,
          placeholder: 'e.g. 标准马甲',
          pos: { col: 2, row: 2, size: 1 },
        },
      ],
    },
  ],
}
